import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';

import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import { TRANSITION_DURATION_FAST } from './common/transition';
import { pathByName } from './icons/icon.utils';

export type IconName = keyof typeof pathByName;

const DEFAULT_ICON_SIZE = 24;

/** Icon Component */
@customElement('te-icon')
export class TeIcon extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .icon-component-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      svg {
        transition: color ${TRANSITION_DURATION_FAST}ms ease-in-out;
      }
    `,
  ];

  /** Uniform size of icon */
  @property({ type: Number }) size = DEFAULT_ICON_SIZE;
  /** Uniform size of wrapper around icon */
  @property({ type: Number }) wrapperSize?: number;
  /** Icon name from icon pack */
  @property({ type: String }) name: IconName = 'pentagon';
  /** Color for icon svg */
  @property({ type: String }) color = theme.colors.shade5.toString();

  getWrapperStyle() {
    const wSize = this.wrapperSize !== undefined ? this.wrapperSize : this.size;

    return {
      width: `${wSize}px`,
      height: `${wSize}px`,
    };
  }
  render() {
    const path = pathByName[this.name] || '';
    return html`
      <div class="icon-component-wrapper" style=${styleMap(this.getWrapperStyle())}>
        <svg
          viewBox="${path.viewport}"
          width="${this.size}"
          height="${this.size}"
          style="flex-shrink: 0; color: ${this.color}; ${path.style}"
          xmlns="http://www.w3.org/2000/svg"
        >
          ${path.path}
        </svg>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-icon': TeIcon;
  }
}
